export default "__VITE_ASSET__DZEBE_8w__"